import MapViewDLPVariant from './MapViewDLPVariant.component';
export default MapViewDLPVariant;